export const checkIfIsInIPad = () =>
  /iPad/.test(navigator.userAgent) ||
  /iPad/.test(navigator.platform) ||
  // @ts-expect-error Property "standalone" is only in Safari
  (navigator.platform === 'MacIntel' && typeof navigator.standalone !== 'undefined')
